import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 500.000000 500.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" >
<path d="M2975 4130 c-4 -17 -3 -35 1 -39 5 -4 37 -13 71 -19 86 -15 164 -56
231 -122 91 -88 137 -185 149 -312 l6 -68 38 0 c38 0 39 1 39 35 0 20 -7 70
-16 112 -47 230 -236 408 -465 439 -46 6 -47 6 -54 -26z"/>
<path d="M1502 3455 l3 -615 330 -2 330 -2 3 317 2 317 325 0 325 0 0 300 0
300 -660 0 -660 0 2 -615z"/>
<path d="M2964 3976 c-8 -45 -2 -52 45 -59 130 -17 240 -139 257 -283 l7 -54
38 0 39 0 0 45 c0 109 -74 241 -173 309 -45 31 -163 76 -199 76 -4 0 -10 -15
-14 -34z"/>
<path d="M2956 3815 c-8 -42 -2 -55 26 -55 53 0 128 -88 128 -148 0 -19 6 -22
41 -22 l42 0 -6 52 c-12 94 -96 184 -189 202 -35 6 -36 6 -42 -29z"/>
<path d="M2905 3645 c-29 -28 -31 -51 -9 -83 32 -46 114 -17 114 41 0 22 -43
67 -65 67 -9 0 -27 -11 -40 -25z"/>
<path d="M2835 3458 c-2 -7 -6 -96 -8 -198 -3 -145 -7 -193 -21 -223 -60 -135
-220 -203 -486 -208 -69 -1 -131 -4 -137 -7 -10 -3 -13 -56 -13 -218 l0 -214
147 -163 c80 -89 172 -190 204 -225 l57 -62 387 2 387 3 -167 180 c-93 99
-204 217 -248 263 -45 47 -76 86 -71 91 5 4 45 20 89 36 261 90 436 238 512
432 26 65 27 78 31 295 l4 226 -331 2 c-263 1 -332 -2 -336 -12z"/>
<path d="M2015 2745 c-31 -30 -32 -58 -3 -85 31 -28 72 -26 97 7 24 30 20 58
-11 86 -28 24 -55 21 -83 -8z"/>
<path d="M1485 2719 c-9 -14 3 -111 22 -179 60 -212 257 -381 474 -407 42 -5
47 -3 52 18 14 50 10 54 -60 65 -95 15 -174 56 -253 130 -97 92 -135 172 -155
325 -5 37 -11 48 -28 53 -32 8 -45 7 -52 -5z"/>
<path d="M1646 2663 c14 -114 55 -195 137 -269 57 -51 139 -91 212 -101 l43
-5 4 40 3 40 -56 11 c-137 27 -259 169 -259 301 l0 40 -46 0 -45 0 7 -57z"/>
<path d="M1810 2673 c1 -80 72 -173 158 -207 71 -27 82 -23 82 29 0 39 -3 45
-20 45 -56 0 -126 67 -136 131 -6 38 -8 39 -45 39 -38 0 -39 -1 -39 -37z"/>
<path d="M1450 1731 l0 -111 25 0 c21 0 25 5 25 30 0 25 4 30 24 30 17 0 31
-10 43 -30 13 -22 25 -30 46 -30 l28 0 -20 29 c-25 35 -26 45 -6 61 8 7 15 29
15 50 0 55 -26 74 -111 78 l-69 4 0 -111z m130 49 c17 -32 -4 -60 -45 -60 -34
0 -35 1 -35 40 0 39 1 40 35 40 24 0 37 -6 45 -20z"/>
<path d="M1701 1743 c-23 -54 -45 -104 -48 -110 -3 -9 4 -13 21 -13 19 0 27 6
32 25 6 23 11 25 58 25 47 0 54 -3 64 -25 7 -15 20 -25 32 -25 26 0 24 9 -31
130 -30 69 -42 86 -61 88 -21 3 -29 -8 -67 -95z m87 -3 c11 -30 10 -30 -23
-30 l-35 0 17 35 c18 39 27 38 41 -5z"/>
<path d="M1910 1730 l0 -110 25 0 c23 0 25 4 25 45 l0 45 50 0 50 0 0 -45 c0
-41 2 -45 25 -45 l25 0 0 110 0 110 -25 0 c-23 0 -25 -4 -25 -45 l0 -45 -50 0
-50 0 0 45 c0 41 -2 45 -25 45 l-25 0 0 -110z"/>
<path d="M2160 1730 c0 -103 1 -110 20 -110 18 0 20 7 20 63 1 60 1 61 18 41
9 -12 25 -36 34 -53 9 -17 21 -31 27 -31 5 0 22 23 38 52 l28 52 3 -62 c3 -58
4 -62 27 -62 l25 0 0 111 c0 109 0 110 -22 107 -16 -2 -33 -22 -57 -65 -19
-35 -37 -63 -41 -63 -3 0 -23 29 -43 65 -26 45 -43 65 -57 65 -19 0 -20 -7
-20 -110z"/>
<path d="M2476 1735 c-25 -58 -46 -108 -46 -110 0 -3 11 -5 24 -5 17 0 26 7
30 25 6 23 11 25 60 25 49 0 54 -2 60 -25 5 -18 13 -25 31 -25 14 0 25 2 25 4
0 2 -20 50 -45 107 -37 87 -48 104 -68 107 -22 3 -29 -7 -71 -103z m92 3 c11
-27 11 -28 -23 -28 -33 0 -34 1 -24 26 20 53 25 53 47 2z"/>
<path d="M2690 1730 l0 -110 59 0 c104 0 151 34 151 109 0 75 -48 111 -149
111 l-61 0 0 -110z m138 54 c16 -11 22 -25 22 -54 0 -46 -26 -70 -77 -70 l-33
0 0 70 0 70 33 0 c18 0 43 -7 55 -16z"/>
<path d="M3001 1823 c-12 -24 -81 -190 -81 -197 0 -3 9 -6 20 -6 12 0 25 10
32 25 10 22 17 25 64 25 47 0 52 -2 58 -25 5 -19 13 -25 32 -25 17 0 24 4 21
13 -3 6 -25 56 -48 110 -36 82 -46 97 -65 97 -13 0 -28 -8 -33 -17z m37 -111
c-40 -4 -43 0 -22 39 l17 33 17 -35 18 -34 -30 -3z"/>
<path d="M3150 1820 c0 -16 7 -20 35 -20 l35 0 0 -90 c0 -89 0 -90 25 -90 25
0 25 1 25 90 l0 90 35 0 c28 0 35 4 35 20 0 19 -7 20 -95 20 -88 0 -95 -1 -95
-20z"/>
<path d="M3391 1743 c-23 -54 -45 -104 -48 -110 -3 -9 4 -13 21 -13 19 0 27 6
32 25 6 23 11 25 60 25 49 0 54 -2 60 -25 4 -18 13 -25 30 -25 13 0 24 3 24 8
0 4 -20 52 -43 107 -37 85 -47 100 -68 103 -23 3 -29 -6 -68 -95z m87 -3 c11
-30 10 -30 -23 -30 l-35 0 17 35 c18 39 27 38 41 -5z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
